import React, { useState } from "react";
import { showError, showSuccess } from "../../utils/toastUtils";
import userAPI from "../../api/UserApi";

function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    if (!currentPassword) {
      newErrors.currentPassword = "Please Enter Current Password";
    } else if (currentPassword.length < 6) {
      newErrors.currentPassword =
        "Current Password must be at least 6 characters";
    }

    if (!newPassword) {
      newErrors.newPassword = "Please Enter New Password";
    } else if (newPassword.length <= 6) {
      newErrors.newPassword = "New Password must be at least 6 characters";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Please Enter Confirm Password";
    } else if (confirmPassword.length <= 6) {
      newErrors.confirmPassword =
        "Confirm Password must be at least 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDetailsSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    const payload = {
      newPassword,
      currentPassword,
      confirmPassword,
    };

    try {
      const res = await userAPI.updatePassword(payload);
      if (res.code === 200) {
        showSuccess(res.message);
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <>
      <div className="my-acount-content account-dashboard mb-5">
        <div className="tf-product-side-accordions">
          <div id="contact">
            <h6>Update Password</h6>
            <div className="box-ip-checkout mt-3">
              <fieldset className="mb-3 tf-field style-2 style-3">
                <input
                  className="tf-field-input tf-input"
                  type="password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                />
                <label className="tf-field-label" htmlFor="currentPassword">
                  Current Password
                </label>
                {errors.currentPassword && (
                  <span className="text-danger">{errors.currentPassword}</span>
                )}
              </fieldset>

              <fieldset className="mb-3 tf-field style-2 style-3">
                <input
                  className="tf-field-input tf-input"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <label className="tf-field-label" htmlFor="newPassword">
                  New Password
                </label>
                {errors.newPassword && (
                  <span className="text-danger">{errors.newPassword}</span>
                )}
              </fieldset>

              <fieldset className="mb-3 tf-field style-2 style-3">
                <input
                  className="tf-field-input tf-input"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <label className="tf-field-label" htmlFor="confirmPassword">
                  Confirm Password
                </label>
                {errors.confirmPassword && (
                  <span className="text-danger">{errors.confirmPassword}</span>
                )}
              </fieldset>

              <button
                className="shop-btn w-25"
                onClick={handleDetailsSubmit}
              >
                Update Password
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangePassword;
